(ns app.front.dashboard.permit-number-search
  (:require [app.domain.municipality.model :as municipality-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::quick-find-result #(-> % ::data :quick-find-result seq))
(rf/reg-sub ::no-results? #(-> % ::data :no-results?))
(rf/reg-sub ::search-open? #(-> % ::data :search-open? boolean))
(rf/reg-sub ::loading? #(-> % ::data :loading? boolean))

(rf/reg-event-db ::clear-search
  #(dissoc % ::data))

(rf/reg-event-db ::open-search
  (fn [db _]
    (assoc-in db [::data :search-open?] true)))

(rf/reg-event-fx ::navigate-ws
  (fn [_ [_ ws-id]]
    {:route/push {:route  :view/workspace
                  :params {:workspace-id ws-id}}
     :dispatch   [::clear-search]}))

(rf/reg-event-fx ::close-search
  (fn [_ _]
    {:dispatch-debounce [{:id     ::search
                          :action :cancel}]
     :dispatch          [::clear-search]}))

(rf/reg-event-db ::find.success
  (fn [db [_ _ result]]
    (assoc-in db [::data :quick-find-result] (:results result))))

(rf/reg-event-db ::find.done
  (fn [db [_ status result]]
    (cond-> db
      (or (not= status 200)
          (-> result :total-count (= 0)))
      (assoc-in [::data :no-results?] true)
      true
      (assoc-in [::data :loading?] false))))

(rf/reg-event-fx ::find-ws
  (fn [{:keys [db]} [_ search-term]]
    {:db           (p/dissoc-in db [::data :no-results?])
     :comm/command {:command          :workspace/find
                    :data             {:case-or-ws-id search-term}
                    :on-success       [::find.success]
                    :finally-dispatch [::find.done]}}))

(rf/reg-event-fx ::search
  (fn [{:keys [db]} [_ search-term]]
    {:db                (assoc-in db [::data :loading?] true)
     :dispatch-debounce [{:id      ::search
                          :timeout 500
                          :action  :dispatch
                          :event   [::find-ws search-term]}]}))

(defn open-workspace-button [tr]
  (let [lang         (<sub [:language])
        search-open? (<sub [::search-open?])
        results      (<sub [::quick-find-result])
        no-results?  (<sub [::no-results?])
        loading?     (<sub [::loading?])]
    [:div.w-full.md:w-auto.mt-4
     (if search-open?
       [:div.relative.max-w-full.sm:w-96.h-12
        [:div.bg-ui-blue-20.rounded-md.flex-col.sm:w-96.p-1.absolute.z-0.top-0
         {:class [(when no-results? "border-solid border-2 border-ui-red-100")]}
         [:div.flex.flex-row
          [:span.p-1
           (cc/icon {:icon        i/remove
                     :description (tr [:close])
                     :fill        "currentcolor"
                     :view-box    "0 0 16 16"
                     :height      "12"
                     :width       "12"
                     :class-name  "mt-2 mr-2 cursor-pointer"
                     :on-click    #(>evt [::close-search])})]
          [ui/text-input
           {:id          "ws-quick-search"
            :light       true
            :placeholder (tr [:dashboard-search/quick-search-placeholder])
            :hide-label  true
            :label-text  ""
            :auto-focus  true
            :on-change   #(when (-> % futil/tval count (> 1))
                            (rf/dispatch-sync [::search (futil/tval %)]))
            :on-key-up   #(when (and (futil/enter-press? %)
                                     (-> results count (= 1)))
                            (>evt [::navigate-ws (-> results first :workspace/id)]))}]
          (cc/button (merge {:id         "navigate-ws"
                             :title      (tr [:dashboard-search/navigate-to-ws])
                             :kind       :tertiary
                             :size       :small
                             :class-name "ml-2"}
                            (if (-> results count (= 1))
                              {:on-click #(>evt [::navigate-ws (-> results first :workspace/id)])}
                              {:disabled true}))
                     (if loading?
                       (cc/loading-spinner {:with-overlay false
                                            :small        true})
                       (tr [:dashboard-search/quick-search-go])))]
         [:div.flex-col.relative
          (if no-results?
            [:div.p-4.font-bold
             (tr [:dashboard-search/workspace-not-found])]
            (when (-> results count (> 1))
              [:div.absolute.bg-ui-blue-20.rounded-b-md.flex-col.lg:w-96.p-1.mb-2.-ml-1.z-10
               (futil/for-frag [{:workspace/keys [id address] :as item} results]
                 [:div.flex.hover:bg-ui-blue-10.cursor-pointer.p-2.leading-10.cursor-pointer
                  {:on-click #(>evt [::navigate-ws id])}
                  (str address ", " (municipality-model/municipality-name item lang))])]))]]]
       (cc/button {:id       "open-search"
                   :kind     :tertiary
                   :on-click #(>evt [::open-search])}
                  (tr [:dashboard-search/go-to-ws])))]))
